import React, { Component } from "react";
import { observer } from "mobx-react";
import "./MyAccount.scss";
import MyAccountState from "./MyAccountState";
import parseTrackCount from "../../utils/parseTrackCount";

/**
 * @typedef {Object} MyAccountProps
 * @property {MyAccountState} store - The account state store
 */

@observer
class MyAccount extends Component {
  render() {
    if (this.props.store.currentPage === "list") {
      const rows = [];
      const organized = this.props.store.savedTracksOrganized();

      for (let i = 0; i < organized.length; i += 1) {
        const savedTrack = organized[i];
        // console.log(savedTrack);
        const descriptionCell = null;

        /** @type {Date} */
        const modifiedOnDate = new Date(
          parseInt(savedTrack.modified_on, 10)
        );
        let hour = modifiedOnDate.getHours();
        const minutes = modifiedOnDate.getMinutes();
        let suffix = "am";
        if (hour > 12) {
          hour -= 12;
          suffix = "pm";
        }
        let timeText = "";
        if (minutes < 10) {
          timeText = `${hour}:0${minutes}${suffix}`;
        } else {
          timeText = `${hour}:${minutes}${suffix}`;
        }

        let title;
        if (this.props.store.editingPlaylistId === savedTrack.id) {
          title = (
            <input
              type={"text"}
              className={"MyAccount-edit-playlist-input"}
              onBlur={this.props.store.commitSearchRename}
              value={this.props.store.editingPlaylistName}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") {
                  e.preventDefault();
                  this.props.store.commitSearchRename();
                }
              }}
              onChange={e => {
                this.props.store.setEditingPlaylistName(e.target.value);
              }}
              autoFocus
            />
          );
        } else {
          title = (
            <button
              type={"button"}
              title={"Double click to rename playlist"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.viewSearch(savedTrack.id);
              }}
              onDoubleClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.doubleClickSearch(savedTrack);
              }}
            >
              {savedTrack.name}
            </button>
          );
        }

        rows.push(
          <tr key={savedTrack.id}>
            <td>{title}</td>
            {descriptionCell}
            <td>{parseTrackCount(savedTrack.tracks, savedTrack.track_count)}</td>
            <td>
              {`${modifiedOnDate.toLocaleDateString("en-US")} ${timeText}`}
            </td>
            <td>
              <a
                href={""}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.getShortLink(savedTrack.id);
                }}
              >
                share
              </a>
              {" | "}
              <a
                href={""}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.deletePlaylist(savedTrack);
                }}
              >
                delete
              </a>
              {" | "}
              <a
                href={""}
                target={"_blank"}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.downloadList(savedTrack);
                }}
                rel={"noreferrer"}
              >
                download
              </a>
              {" | "}
              <a
                href={""}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.duplicatePlaylist(savedTrack.id);
                }}
              >
                duplicate
              </a>
            </td>
            <td
              className={`${
                this.props.store.searchState.isAdmin ? "" : "hide"
              }`}
            >
              {savedTrack.linked_video_id ? `Yes` : ``}
            </td>
            <td
              className={`${
                this.props.store.searchState.isAdmin ? "has-icon_x" : "hide"
              }`}
            >
              {/* <div
                className={"regenerate-icon fa-solid fa-rotate-right"}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.regeneratePassword();
                }}
              /> */}
              <input
                className={"password-field"}
                defaultValue={savedTrack.password ? savedTrack.password : ""}
                onBlur={this.props.store.savePassword}
                onChange={e => {
                  this.props.store.setPasswordValue(
                    savedTrack.id,
                    e.target.value
                  );
                }}
                onKeyDown={e => {
                  e.stopPropagation();
                  if (e.key === "Enter") {
                    e.preventDefault();
                    e.target.blur();
                  }
                }}
              />
            </td>
          </tr>
        );
      }

      return (
        <div className={"MyAccount"}>
          <div className={"MyAccount-list-top-banner"}>
            <div className={"MyAccount-list-top-banner-title"}>
              my saved playlists
            </div>
            <div
              className={"Popup-banner-close"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.close();
              }}
            />
            <div className={"MyAccount-list-top-banner-logout"}>
              <a
                href={""}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.logout();
                }}
              >
                logout
              </a>
            </div>
          </div>
          <div className={"MyAccount-header"}>
            <input
              className={`Search-filter`}
              ref={r => {
                if (this.props.store.showingPanelFirst === 0) {
                  if (r != null) r.focus();
                  this.props.store.showSearchFilter();
                  this.props.store.filterPlaylists("");
                }
              }}
              onChange={e => {
                this.props.store.filterPlaylists(e.target.value);
              }}
              onKeyDown={e => {
                e.stopPropagation();
              }}
              placeholder={"Type to filter saved playlists"}
            />
          </div>
          <div className={"MyAccount-list-table-holder"}>
            <table className={"MyAccount-list-table"}>
              <thead>
                <tr>
                  <td className={"MyAccount-name-column"}>
                    <div
                      className={"MyAccount-column-header"}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.props.store.toggleSortColumn("track name");
                      }}
                    >
                      <div className={"MyAccount-column-buttons"} />
                      <div className={"MyAccount-column-text"}>
                        playlist name
                      </div>
                      <div className={"MyAccount-column-buttons"}>
                        <div
                          className={`MyAccount-column-buttons-upper-triangle${
                            this.props.store.sortColumn === "track name" &&
                            this.props.store.sortDirection === "up"
                              ? " MyAccount-column-buttons-upper-triangle-active"
                              : ""
                          }`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.store.setSortColumn("track name", "up");
                          }}
                        />
                        <div
                          className={`MyAccount-column-buttons-lower-triangle${
                            this.props.store.sortColumn === "track name" &&
                            this.props.store.sortDirection === "down"
                              ? " MyAccount-column-buttons-lower-triangle-active"
                              : ""
                          }`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.store.setSortColumn(
                              "track name",
                              "down"
                            );
                          }}
                        />
                      </div>
                    </div>
                  </td>
                  {/* <td className={'MyAccount-notes-column'}> */}
                  {/*  <div className={'MyAccount-column-text'}>notes</div> */}
                  {/* </td> */}
                  <td className={"MyAccount-track-count-column"}>
                    <div
                      className={"MyAccount-column-header"}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.props.store.toggleSortColumn("track count");
                      }}
                    >
                      <div className={"MyAccount-column-buttons"} />
                      <div className={"MyAccount-column-text"}>tracks</div>
                      <div className={"MyAccount-column-buttons"}>
                        <div
                          className={`MyAccount-column-buttons-upper-triangle${
                            this.props.store.sortColumn === "track count" &&
                            this.props.store.sortDirection === "up"
                              ? " MyAccount-column-buttons-upper-triangle-active"
                              : ""
                          }`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.store.setSortColumn("track count", "up");
                          }}
                        />
                        <div
                          className={`MyAccount-column-buttons-lower-triangle${
                            this.props.store.sortColumn === "track count" &&
                            this.props.store.sortDirection === "down"
                              ? " MyAccount-column-buttons-lower-triangle-active"
                              : ""
                          }`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.store.setSortColumn(
                              "track count",
                              "down"
                            );
                          }}
                        />
                      </div>
                    </div>
                  </td>
                  <td className={"MyAccount-modified-column"}>
                    <div
                      className={"MyAccount-column-header"}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.props.store.toggleSortColumn("modified");
                      }}
                    >
                      <div className={"MyAccount-column-buttons"} />
                      <div className={"MyAccount-column-text"}>modified</div>
                      <div className={"MyAccount-column-buttons"}>
                        <div
                          className={`MyAccount-column-buttons-upper-triangle${
                            this.props.store.sortColumn === "modified" &&
                            this.props.store.sortDirection === "up"
                              ? " MyAccount-column-buttons-upper-triangle-active"
                              : ""
                          }`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.store.setSortColumn("modified", "up");
                          }}
                        />
                        <div
                          className={`MyAccount-column-buttons-lower-triangle${
                            this.props.store.sortColumn === "modified" &&
                            this.props.store.sortDirection === "down"
                              ? " MyAccount-column-buttons-lower-triangle-active"
                              : ""
                          }`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.store.setSortColumn("modified", "down");
                          }}
                        />
                      </div>
                    </div>
                  </td>
                  <td className={"MyAccount-controls-column"} />
                  <td
                    className={`MyAccount-has-video-column ${
                      this.props.store.searchState.isAdmin ? "" : "hide"
                    }`}
                  >
                    Has Video
                  </td>
                  <td
                    className={`MyAccount-password-column ${
                      this.props.store.searchState.isAdmin ? "" : "hide"
                    }`}
                  >
                    Password
                  </td>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "save") {
      // Build the option to merge this with other searches, if we have any other searches saved

      const merge = null;
      /*
      if (this.props.store.savedTracks.length > 0) {
        let mergeOptions = [];
        mergeOptions.push(
          <option disabled key={'none'} value={''}/>
        );
        for (const savedTrack of this.props.store.savedTracks) {
          mergeOptions.push(
            <option key={savedTrack.id} value={savedTrack.id}>{savedTrack.name}</option>
          );
        }
        merge = (
          <div>
            <div className={'MyAccount-or-merge-block'}>
              or
            </div>
            <div className={'MyAccount-merge-instructions-block'}>
              merge liked tracks to an existing search?
            </div>
            <div>
              <div className={'MyAccount-styled-select'}>
                <select value={this.props.store.mergeIntoId} onChange={(e) => {
                  this.props.store.setMergeIntoId(e.target.value)
                }}>
                  {mergeOptions}
                </select>
              </div>
            </div>
            <div>
              <button onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.mergeWithOtherSearch();
              }}>merge</button>
            </div>
          </div>
        );
      }
      */

      let allowSaving = true;
      let allowOverwrite = false;
      let error = null;
      if (this.props.store.saveName.length === 0) {
        allowSaving = false;
      }
      for (let i = 0; i < this.props.store.savedTracks.length; i += 1) {
        const track = this.props.store.savedTracks[i];
        if (track.name === this.props.store.saveName) {
          this.props.store.overwritePlaylistName(track.id);
          allowSaving = false;
          allowOverwrite = true;
          error = (
            <div className={"MyAccount-error-msg"}>
              There is already a saved playlist with this name. Would you like
              to replace it?
            </div>
          );
        }
      }

      let overwrite = null;
      if (allowOverwrite) {
        overwrite = (
          <span>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.saveNewSearch();
              }}
            >
              replace
            </button>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.setSaveName(``);
              }}
            >
              rename
            </button>
          </span>
        );
      }

      return (
        <div className={"MyAccount Save-Search"}>
          <div className={"MyAccount-header"}>save this search</div>
          <div>
            <input
              type={"text"}
              placeholder={"title of your search"}
              className={"MyAccount-text-input"}
              value={this.props.store.saveName}
              onKeyDown={e => {
                if (e.key === "Enter" && allowSaving) {
                  this.props.store.saveNewSearch();
                }
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setSaveName(e.target.value);
              }}
              ref={r => {
                if (r != null) {
                  setTimeout(() => {
                    if (r != null) r.focus();
                  }, 100);
                }
              }}
              autoFocus
            />
          </div>
          {error}
          <div className={"buttons"}>
            {overwrite}
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.close();
              }}
            >
              cancel
            </button>
            <button
              type={"button"}
              className={
                allowSaving
                  ? ""
                  : `button-disabled ${allowOverwrite ? "hide" : ""}`
              }
              onClick={e => {
                if (allowSaving) {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.nullifyOverwritePlaylistId();
                  this.props.store.saveNewSearch();
                }
              }}
            >
              create
            </button>
          </div>
          {merge}
        </div>
      );
    }
    return <div>Error</div>;
  }
}

export default MyAccount;
